/**
 * @generated SignedSource<<aa5463a54482ee251423e01fa2434721>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LearnableKind = "Course" | "GroupCoaching" | "MicroLearning" | "OneToOneCoaching";
export type licenses_Query$variables = {
  kinds: ReadonlyArray<LearnableKind>;
};
export type licenses_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"licenseSettings_QueryFragment" | "licensesTab_LicensesTabFragment" | "manageLicensesTab_ManageLicensesTabFragment">;
};
export type licenses_Query = {
  response: licenses_Query$data;
  variables: licenses_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "kinds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "kinds",
    "variableName": "kinds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v5 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isLicenseGrouping"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalLicenseAmount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usedLicenseAmount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalLicenseAmountForUser",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usedLicenseAmountForUser",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "assignmentRules",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "licenseGroupingId",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "ContractPartner",
  "kind": "LinkedField",
  "name": "contractPartner",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContractPartnerData",
      "kind": "LinkedField",
      "name": "data",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkToAGB",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "CoachingOfferDescription",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v11/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v15 = [
  (v2/*: any*/),
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "extension",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMicroLearning",
          "storageKey": null
        },
        (v12/*: any*/)
      ],
      "type": "PublishedConstellationRootExtensionExtension",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnOpportunityV2",
    "kind": "LinkedField",
    "name": "root",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "structureDefinition",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v16/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "extension",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/)
                    ],
                    "type": "PublishedRootExtensionImpl",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "LearnOpportunityRootStructureDefinition",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v2/*: any*/),
      (v18/*: any*/),
      (v13/*: any*/)
    ],
    "storageKey": null
  }
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "CartClickout",
  "kind": "LinkedField",
  "name": "cartClickout",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "relativeLink",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = [
  (v2/*: any*/),
  (v14/*: any*/),
  (v20/*: any*/)
],
v22 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnOpportunityV2",
    "kind": "LinkedField",
    "name": "root",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "structureDefinition",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v16/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "extension",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/),
                      (v20/*: any*/)
                    ],
                    "type": "PublishedRootExtensionImpl",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "LearnOpportunityRootStructureDefinition",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v2/*: any*/),
      (v18/*: any*/),
      (v13/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "licenses_Query",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "licenseSettings_QueryFragment"
      },
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "licensesTab_LicensesTabFragment"
      },
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "manageLicensesTab_ManageLicensesTabFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "licenses_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "accounts",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "accountExtensionKind",
                            "value": "Academies"
                          }
                        ],
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "licenseModelKind",
                                "storageKey": null
                              }
                            ],
                            "type": "AcademiesAccountExtension",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": "extension(accountExtensionKind:\"Academies\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LicenseGroupingQueries",
        "kind": "LinkedField",
        "name": "LicenseGrouping",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "LicenseGroupingsConnection",
            "kind": "LinkedField",
            "name": "MyLicenses",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LicenseGroupingsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "learnable",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CoachingOffer",
                                    "kind": "LinkedField",
                                    "name": "groupCoaching",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "PublishedGroupCoachingLearnable",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CoachingOffer",
                                    "kind": "LinkedField",
                                    "name": "oneToOneCoaching",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "PublishedOneToOneCoachingLearnable",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v19/*: any*/),
                                "type": "PublishedCourseLearnable",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v19/*: any*/),
                                "type": "PublishedMicroLearningLearnable",
                                "abstractKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LearnableLicenseGrouping",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "LicenseGroupingsConnection",
            "kind": "LinkedField",
            "name": "LicenseGroupings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LicenseGroupingsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "learnable",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CoachingOffer",
                                    "kind": "LinkedField",
                                    "name": "groupCoaching",
                                    "plural": false,
                                    "selections": (v21/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "PublishedGroupCoachingLearnable",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CoachingOffer",
                                    "kind": "LinkedField",
                                    "name": "oneToOneCoaching",
                                    "plural": false,
                                    "selections": (v21/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "PublishedOneToOneCoachingLearnable",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "PublishedCourseLearnable",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "PublishedMicroLearningLearnable",
                                "abstractKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LearnableLicenseGrouping",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "771dd10eb8da6ae591390b21ab6ea563",
    "id": null,
    "metadata": {},
    "name": "licenses_Query",
    "operationKind": "query",
    "text": "query licenses_Query(\n  $kinds: [LearnableKind!]!\n) {\n  ...licenseSettings_QueryFragment\n  ...licensesTab_LicensesTabFragment_4gKp9u\n  ...manageLicensesTab_ManageLicensesTabFragment_4gKp9u\n}\n\nfragment licenseContextMenu_LicenseFragment on LicenseGrouping {\n  __isLicenseGrouping: __typename\n  id\n  ... on LearnableLicenseGrouping {\n    learnable {\n      __typename\n      ... on PublishedGroupCoachingLearnable {\n        groupCoaching {\n          cartClickout {\n            relativeLink\n          }\n          id\n        }\n      }\n      ... on PublishedOneToOneCoachingLearnable {\n        oneToOneCoaching {\n          cartClickout {\n            relativeLink\n          }\n          id\n        }\n      }\n      ... on PublishedCourseLearnable {\n        root {\n          structureDefinition {\n            __typename\n            ... on LearnOpportunityRootStructureDefinition {\n              extension {\n                __typename\n                ... on PublishedRootExtensionImpl {\n                  cartClickout {\n                    relativeLink\n                  }\n                }\n              }\n            }\n          }\n          id\n        }\n      }\n      ... on PublishedMicroLearningLearnable {\n        root {\n          structureDefinition {\n            __typename\n            ... on LearnOpportunityRootStructureDefinition {\n              extension {\n                __typename\n                ... on PublishedRootExtensionImpl {\n                  cartClickout {\n                    relativeLink\n                  }\n                }\n              }\n            }\n          }\n          id\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment licenseSettings_QueryFragment on Query {\n  Viewer {\n    Auth {\n      currentUser {\n        accounts {\n          id\n          extension(accountExtensionKind: Academies) {\n            __typename\n            kind\n            ... on AcademiesAccountExtension {\n              licenseModelKind\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment licensesGroupCard_LicenseGroupingFragment on LicenseGrouping {\n  __isLicenseGrouping: __typename\n  id\n  kind\n  totalLicenseAmount\n  usedLicenseAmount\n  totalLicenseAmountForUser\n  usedLicenseAmountForUser\n  assignmentRules {\n    __typename\n    licenseGroupingId\n    id\n  }\n  ... on MicroLearningLicenseGrouping {\n    id\n  }\n  ... on LearnableLicenseGrouping {\n    learnable {\n      __typename\n      kind\n      ... on PublishedGroupCoachingLearnable {\n        groupCoaching {\n          id\n          description {\n            contractPartner {\n              data {\n                name\n                linkToAGB\n              }\n              id\n            }\n            name\n            image {\n              thumbnail\n              id\n            }\n          }\n        }\n      }\n      ... on PublishedOneToOneCoachingLearnable {\n        oneToOneCoaching {\n          id\n          description {\n            contractPartner {\n              data {\n                name\n                linkToAGB\n              }\n              id\n            }\n            name\n            image {\n              thumbnail\n              id\n            }\n          }\n        }\n      }\n      ... on PublishedCourseLearnable {\n        root {\n          structureDefinition {\n            __typename\n            title\n            ... on LearnOpportunityRootStructureDefinition {\n              extension {\n                __typename\n                ... on PublishedRootExtensionImpl {\n                  extension {\n                    __typename\n                    ... on PublishedConstellationRootExtensionExtension {\n                      isMicroLearning\n                      contractPartner {\n                        data {\n                          name\n                          linkToAGB\n                        }\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          id\n          description\n          image {\n            thumbnail\n            id\n          }\n        }\n      }\n      ... on PublishedMicroLearningLearnable {\n        root {\n          structureDefinition {\n            __typename\n            title\n            ... on LearnOpportunityRootStructureDefinition {\n              extension {\n                __typename\n                ... on PublishedRootExtensionImpl {\n                  extension {\n                    __typename\n                    ... on PublishedConstellationRootExtensionExtension {\n                      isMicroLearning\n                      contractPartner {\n                        data {\n                          name\n                          linkToAGB\n                        }\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          id\n          description\n          image {\n            thumbnail\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment licensesTab_LicensesTabFragment_4gKp9u on Query {\n  LicenseGrouping {\n    MyLicenses(kinds: $kinds) {\n      edges {\n        node {\n          __typename\n          id\n          ...licensesGroupCard_LicenseGroupingFragment\n        }\n      }\n    }\n  }\n}\n\nfragment manageLicensesTab_ManageLicensesTabFragment_4gKp9u on Query {\n  LicenseGrouping {\n    LicenseGroupings(kinds: $kinds) {\n      edges {\n        node {\n          __typename\n          id\n          ...licensesGroupCard_LicenseGroupingFragment\n          ...licenseContextMenu_LicenseFragment\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3bf45599d2281944f93367bf02067c2c";

export default node;
